<template>
	<div>
		<div style="text-align: left">
			<div class="signal-title">
				<h4>{{ portfolio.name }}</h4>
			</div>
			<div class="portfolio-tabs">
				<template v-for="page in pages">
					<button :class="['btn', (page === curPage ? 'btn-primary' : '')]"
							@click="selectPage(page)">
						{{page}}
					</button>
				</template>
			</div>
		</div>

		<div class="main-tab-content" v-show="curPage === 'Summary'">
			<sig-portfolio-summary :portfolio="portfolio">
			</sig-portfolio-summary>
		</div>
		<div class="main-tab-content" v-show="curPage === 'Charts'">
			<sig-portfolio-charts :portfolio="portfolio">
			</sig-portfolio-charts>
		</div>
		<div class="main-tab-content" v-show="curPage === 'Orders'">
			<sig-portfolio-orders :portfolio="portfolio">
			</sig-portfolio-orders>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex';
	import SigPortfolioSummary from './sig-portfolio-summary.vue';
	import SigPortfolioCharts from './sig-portfolio-charts.vue';
	import SigPortfolioOrders from './sig-portfolio-orders.vue';

	export default {
		components: {
			'sig-portfolio-summary': SigPortfolioSummary,
			'sig-portfolio-charts': SigPortfolioCharts,
			'sig-portfolio-orders': SigPortfolioOrders
		},
		props: [],
		data() {
			return { 
				portfolio: {},
				curPage: 'Summary',
				pages: ['Summary', 'Charts', 'Orders']
			};
		},
		computed: {
			...mapGetters({
	        	getPortfolio: 'portfolios/portfolio'
	        })
		},
		methods: {
			selectPage(page) {
				if (page !== this.curPage)
					this.curPage = page;
			},
			buildPortfolio() {
				let i = +this.$route.params.id;
				return {
							id: i,
							name: `MasterForex ${i}`,
							rating: 1.5 + Math.random() * (5 - 1.5),
							currency: 'BTC',
							twr: Math.random() * 100 - 20,
							profit: 0.21 - i/30,
							sharp: 1.02 - i/50,
							sortino: 1.12 - i / 50,
							drawdown: 20.01 + i,
							term: 301,
							chart: []
						};
			}
		},
		beforeMount() {
			setTimeout(() => {
				this.$set(this, 'portfolio', this.buildPortfolio());
			},0);
		}
	};
</script>

<style scoped>
	div.signal-title {
		display: inline-block;
		width: 190px;
	}
	div.portfolio-tabs {
		display: inline-block;
	}
	.portfolio-tabs button {
		margin: 2px 5px 2px 5px;
	}
	.main-tab-content {
		margin-top: 8px;
		text-align: left;
	}
</style>